import { Component } from '@angular/core';

@Component({
  selector: 'my-app',
  template: '<contact-form></contact-form>'
})
export class AppComponent { name = 'Angular'; }
